import PropTypes from "prop-types";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import RegionForm from "routes/regions/forms/RegionForm";

const HEADER = "New Region";

const NewRegionModal = ({ onSuccess }) => {
  const [open, setOpen] = useState(false);

  const handleSuccess = async () => {
    setOpen(false);
    await onSuccess();
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger render={<Button size="sm">{HEADER}</Button>} />
      <DialogContent>
        <DialogTitle>{HEADER}</DialogTitle>
        <RegionForm onSuccess={handleSuccess} onCancel={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
};

NewRegionModal.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default NewRegionModal;
